import React from 'react'

import { Button, Typography } from '@material-ui/core'

import DialogAlert from 'components/DialogAlert'
import { CREDINET_URL } from 'constants/urls'

export default function AdminChangeModal({ open, onClose }) {
  const handleGoToCredinet = () => {
    window.location.href = CREDINET_URL
  }

  return (
    <DialogAlert open={open} personalized handleClose={onClose}>
      <div style={{ textAlign: 'center', padding: '10px 12px 0 12px' }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '9999px',
            border: '2px solid #000',
            margin: '0 auto 16px auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 28,
          }}
        >
          !
        </div>
        <Typography style={{ fontSize: 20, marginBottom: 12 }}>Cambio de Administrador</Typography>
        <p style={{ fontSize: 14, marginBottom: 32 }}>
          Ahora que tienes activo Gestiona tu negocio,
          <div>debes ingresar por Credinet usando la opción</div>
          <div>“Gestiona tu negocio”</div>
        </p>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoToCredinet}
          style={{ borderRadius: 100, padding: '8px 30px', marginBottom: 10 }}
        >
          Ir a Credinet
        </Button>
      </div>
    </DialogAlert>
  )
}
